import { Controller } from "@hotwired/stimulus"

// A flash message the merchant can put away. Nothing auto-hides: a notice
// that vanishes while you are reading it is worse than one you dismiss.
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
